import { Controller } from '@hotwired/stimulus';

/**
 * cover-photo-picker — le sélecteur de la photo de couverture du CR (#671, D5/D8).
 *
 * Monté sur le FORMULAIRE d'upload (`PATCH …/photo-de-couverture`, multipart),
 * espace-fusionné avec `file-type-validator`. La pilule « Changer » (ou la strip
 * pointillée « Ajouter une photo de couverture ») est un VRAI `<button>` : elle
 * ouvre le sélecteur de fichier natif via `browse()`, et le choix d'un fichier
 * soumet immédiatement le formulaire — l'utilisateur n'a aucun bouton
 * « Enregistrer » à trouver.
 *
 * Deux détails porteurs :
 *   - `requestSubmit()` et non `submit()` : `submit()` court-circuite la
 *     validation et surtout Turbo, qui n'intercepterait pas la soumission et
 *     rechargerait la page entière au lieu d'appliquer le turbo_stream ;
 *   - le champ est REMIS À ZÉRO après la soumission : sans ça, re-choisir le
 *     MÊME fichier n'émet aucun `change` et le second geste ne part jamais.
 *     La remise à zéro est différée d'un tick, `requestSubmit()` lisant le
 *     FileList de façon synchrone mais la sérialisation multipart, non.
 *
 * `file-type-validator` peut vider le champ sur un type refusé : `submit()`
 * sort alors sans rien envoyer (le garde `files.length`), et l'erreur reste
 * affichée par ce contrôleur-là.
 *
 * Targets:
 *   - input: le `<input type=file>` caché (`class="hidden"` SEULE)
 *
 * Actions:
 *   - click->cover-photo-picker#browse  (la pilule « Changer » / la strip)
 *   - change->cover-photo-picker#submit (le champ caché)
 *
 * @example
 *   <form action="/chantiers/1/comptes-rendus/12/photo-de-couverture"
 *         method="post" enctype="multipart/form-data"
 *         data-controller="cover-photo-picker file-type-validator">
 *     <input type="hidden" name="_method" value="patch">
 *     <button type="button" data-action="cover-photo-picker#browse">Changer</button>
 *     <input type="file" class="hidden" name="meeting_report[cover_photo]"
 *            accept="image/png,image/jpeg,image/jpg,image/heic,image/heif"
 *            data-cover-photo-picker-target="input"
 *            data-file-type-validator-target="input"
 *            data-action="change->file-type-validator#validate change->cover-photo-picker#submit">
 *   </form>
 */
export default class extends Controller {
  static targets = ['input'];

  browse() {
    this.inputTarget.click();
  }

  submit() {
    if (!this.inputTarget.files || this.inputTarget.files.length === 0) return;

    const form = this.element.closest('form') || this.element;
    form.requestSubmit();

    // Différé : la sérialisation multipart de la soumission n'est pas synchrone.
    setTimeout(() => {
      this.inputTarget.value = '';
    }, 0);
  }
}
